import React from 'react';
import { Separator } from './ui/separator';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';
import { contactData } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A3A48] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_07d3bd57-1cae-496c-a699-0d97f10cd5ce/artifacts/25bk249o_EDIF%C3%8DSICA.png"
              alt="EDIFÍSICA"
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-white/80 text-sm leading-relaxed">
              Ingeniería aplicada, física de la construcción e industrialización de soluciones habitacionales sustentables.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#5E8B7E]">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="#nosotros" onClick={(e) => scrollToSection(e, '#nosotros')} className="text-white/80 hover:text-[#5E8B7E] transition-colors text-sm">
                  Nosotros
                </a>
              </li>
              <li>
                <a href="#industrializacion" onClick={(e) => scrollToSection(e, '#industrializacion')} className="text-white/80 hover:text-[#5E8B7E] transition-colors text-sm">
                  Industrialización
                </a>
              </li>
              <li>
                <a href="#sustentabilidad" onClick={(e) => scrollToSection(e, '#sustentabilidad')} className="text-white/80 hover:text-[#5E8B7E] transition-colors text-sm">
                  Sustentabilidad
                </a>
              </li>
              <li>
                <a href="#servicios" onClick={(e) => scrollToSection(e, '#servicios')} className="text-white/80 hover:text-[#5E8B7E] transition-colors text-sm">
                  Servicios
                </a>
              </li>
              <li>
                <a href="#proyectos" onClick={(e) => scrollToSection(e, '#proyectos')} className="text-white/80 hover:text-[#5E8B7E] transition-colors text-sm">
                  Proyectos
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#5E8B7E]">Servicios Destacados</h3>
            <ul className="space-y-2 text-sm text-white/80">
              <li>Acreditación Normativa</li>
              <li>Certificación Energética</li>
              <li>Estudios Acústicos</li>
              <li>Viviendas Industrializadas</li>
              <li>I+D+i</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#5E8B7E]">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start text-sm">
                <MapPin className="mr-2 flex-shrink-0 text-[#5E8B7E]" size={16} />
                <span className="text-white/80">{contactData.address}</span>
              </li>
              <li className="flex items-center text-sm">
                <Phone className="mr-2 flex-shrink-0 text-[#5E8B7E]" size={16} />
                <span className="text-white/80">{contactData.phone}</span>
              </li>
              <li className="flex items-center text-sm">
                <Mail className="mr-2 flex-shrink-0 text-[#5E8B7E]" size={16} />
                <span className="text-white/80">{contactData.email}</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a
                href="#"
                className="p-2 bg-white/10 rounded-full hover:bg-[#5E8B7E] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="#"
                className="p-2 bg-white/10 rounded-full hover:bg-[#5E8B7E] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="p-2 bg-white/10 rounded-full hover:bg-[#5E8B7E] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        <Separator className="bg-white/20 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-white/60">
          <p>© {currentYear} EDIFÍSICA SPA. Todos los derechos reservados.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-[#5E8B7E] transition-colors">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-[#5E8B7E] transition-colors">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;